
export const openingsData = [
    {
        title: 'Senior Full-Stack Developer',
        location: 'Remote',
        type: 'Full-time',
        category: 'Engineering',
        requirements: [
            '5+ years of experience with Node.js & React',
            'Deep understanding of distributed systems',
            'Experience with cloud infrastructure (AWS/Azure)',
        ],
        benefits: [
            'Performance Bonuses',
            'Home office stipend',
            'Flexible work schedule',
        ],
        color: 'blue',
        borderColor: 'border-blue-500/50',
        categoryBg: 'bg-blue-500/10',
        categoryColor: 'text-blue-500',
        categoryBorder: 'border-blue-500/20',
    },
    {
        title: 'UI/UX Designer',
        location: 'Remote',
        type: 'Full-time',
        category: 'Design',
        requirements: [
            'Strong portfolio of web/mobile apps',
            'Proficiency in Figma & Adobe XD',
            'Basic understanding of HTML/CSS',
        ],
        benefits: [
            'Creative workshops',
            'Flexible work schedule',
            'Health insurance',
        ],
        color: 'purple',
        borderColor: 'border-purple-500/50',
        categoryBg: 'bg-purple-500/10',
        categoryColor: 'text-purple-500',
        categoryBorder: 'border-purple-500/20',
    },
    {
        title: 'DevOps Engineer',
        location: 'Remote',
        type: 'Full-time',
        category: 'Infrastructure',
        requirements: [
            '3+ years in a DevOps role',
            'Experience with CI/CD pipelines (Jenkins, GitLab CI)',
            'Strong knowledge of AWS, Docker, and Kubernetes.',
        ],
        benefits: [
            'Flexible work schedule',
            'Health insurance',
            'Performance Bonuses',
        ],
        color: 'green',
        borderColor: 'border-green-500/50',
        categoryBg: 'bg-green-500/10',
        categoryColor: 'text-green-500',
        categoryBorder: 'border-green-500/20',
    },
    {
        title: 'Mobile App Developer',
        location: 'Remote',
        type: 'Contract',
        category: 'Mobile',
        requirements: [
            '2+ years with Flutter or React Native',
            'Experience publishing apps to App Store/Play Store',
            'Strong portfolio of mobile projects.',
        ],
        benefits: [
            'Remote work stipend',
            'Health insurance',
            'Flexible work schedule',
        ],
        color: 'orange',
        borderColor: 'border-orange-500/50',
        categoryBg: 'bg-orange-500/10',
        categoryColor: 'text-orange-500',
        categoryBorder: 'border-orange-500/20',
    },
    {
        title: 'QA Automation Engineer',
        location: 'Meerut, UP, India',
        type: 'Full-time',
        category: 'Quality',
        requirements: [
            'Experience with Selenium or Cypress',
            'Strong understanding of QA methodologies',
            'Experience with performance and load testing tools (JMeter)',
        ],
        benefits: [
            'Health insurance',
            'Team-building events',
            'Performance Bonuses',
        ],
        color: 'red',
        borderColor: 'border-red-500/50',
        categoryBg: 'bg-red-500/10',
        categoryColor: 'text-red-500',
        categoryBorder: 'border-red-500/20',
    },
    {
        title: 'Business Development Executive (IT Sales)',
        location: 'Meerut, UP, India (Hybrid)',
        type: 'Full-time',
        category: 'Sales',
        requirements: [
            '1-3 years experience in IT Sales / Online Bidding (Upwork, Freelancer).',
            'Excellent English communication skills (written and verbal).',
            'Experience writing custom proposals and closing deals.',
            'Basic understanding of web and mobile technologies.',
        ],
        benefits: [
            'Competitive Salary + Incentives',
            'Flexible work hours',
            'Team-building events',
        ],
        color: 'indigo',
        borderColor: 'border-indigo-500/50',
        categoryBg: 'bg-indigo-500/10',
        categoryColor: 'text-indigo-500',
        categoryBorder: 'border-indigo-500/20',
    }
];
